(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-support"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(function() {
      let supportSubNav = document.getElementsByClassName('support-sub-nav');
      let supportSections = document.getElementsByClassName('product-details-accordion-left');

      // create each subNav item & append to supportSubNav
      for(let el = 0; el < supportSections.length; el++) {
        let supportNavElement = document.createElement("a");
        supportNavElement.href = '#'+supportSections[el].innerText.toLowerCase().replace(/[^\w\s]/gi, '').replaceAll(' ', '-');
        //   *****  supportNavElement.href = '#'+supportSections[el].innerHTML.toLowerCase().replace(/[^\w\s]/gi, '').replaceAll(' ', '-'); (JH changed innerHTML to innerText)
        supportNavElement.className = el == 0 ? "supportNavElement active" : "supportNavElement";
        supportNavElement.innerHTML = supportSections[el].innerHTML;
        supportNavElement.onclick = function($e) {
          // logic when user clicks on a supportNavElement - remove active class & add to selected element
          let supportSupportNavElements = document.getElementsByClassName('supportNavElement');
          let selectedElement = $(this)[0];

          for(let subNav = 0; subNav < supportSupportNavElements.length; subNav++) {
            supportSupportNavElements[subNav].classList.remove('active');
          }
          selectedElement.classList.add('active');
        }
        supportSubNav[0].appendChild(supportNavElement);
      }
    }, 3000);

    var selectedTopic = function(selectObject) {
      // let topics = document.getElementsByClassName('support-sub-nav');
      // let value = selectObject.value;  
      console.log('haloooo: ', selectObject);
      // $('#contact_form')[0].attributes[1].value = 'mailto:'+selectObject;
      // window.location.href = 'mailto:peternguyen008@gmail.com?subject=Test subject - ' + name + ' (' + email + ')' + '&body=' + message;
    };

    var sendMail = function() {
      // var name = $('#contact #name').val();
      // var email = $('#contact #email').val();
      // var message = $('#contact textarea').val();
      let topic = $('#Topic')[0].selectedOptions[0].value;
      console.log('topic: ', topic);
      // NEED TO TEST MAIL TO FUNCTIONALITY
      // window.location.href = 'mailto:'+topic+'?subject=The subject - ';
      // window.location.href = 'mailto:'+topic+'?subject=The subject - '+name+'&body='+message;
    };
  });

  } catch(e) { console.error(e); }
})();
})();
